import { Divider, Flex, Heading } from '@zillow/constellation';
import React from 'react';
import ApplicationCard from './ApplicationCard/ApplicationCard';
import { sortApplications } from './ApplicationSection.utils';

/**
 * @param {Object} props
 * @param {Set<string>} props.overallStatuses
 */
export default function ApplicationSection({ data, overallStatuses, header, id }) {
  const { landlordRentalApplications } = data.rentalListing;
  const relevantApplications = landlordRentalApplications.filter((application) =>
    overallStatuses.has(application.overallStatus),
  );
  if (relevantApplications.length === 0) {
    return null;
  }
  const sortedRelevantApplications = sortApplications(relevantApplications);
  const lastApplication = sortedRelevantApplications.pop();
  return (
    <Flex display="flex" flexDirection="column" id={id}>
      <Heading level={4} marginBottom="sm">
        {header}
      </Heading>
      <Divider marginBottom="sm" />
      <Flex display="flex" flexDirection="column">
        {sortedRelevantApplications.map((application) => (
          <>
            <ApplicationCard key={application.id} application={application} />
            <Divider marginY="xs" />
          </>
        ))}
        <ApplicationCard application={lastApplication} />
      </Flex>
    </Flex>
  );
}
